<template>
  <VerticalFooter class="form-footer">
    <HotPinkButton native-type="submit">{{ $t('continue') }}</HotPinkButton>
    <TextButton class="tw-capitalize" @click="$emit('on-back')">
      {{ $t('back') }}
    </TextButton>
  </VerticalFooter>
</template>

<script>
import HotPinkButton from '../buttons/HotPinkButton.vue'
import TextButton from '../buttons/TextButton.vue'
import VerticalFooter from './VerticalFooter.vue'

export default {
  components: {
    VerticalFooter,
    HotPinkButton,
    TextButton,
  },
}
</script>

<style scoped>
.form-footer {
  /* Base */
  @apply tw-mx-0;
}
</style>
